// @flow
import { connect } from 'react-redux';
import { PickLine } from '../../components/common';
import { activeSubscriptionsSelector } from '../../modules/Subscriptions';
import I18n from '../../lib/i18n';
import { subscriptionToPhoneNumber } from '../../modules/Dashboard';
import { suspendLine } from '../../modules/SuspendSwapTerminate';
import FormatService from '../../lib/format';

import type { State } from '../../modules/reducers';
import type { StateProps, DispatchProps } from '../../components/common/PickLine/PickLine';

const mapStateToProps = (state: State): StateProps => ({
  subscriptions: activeSubscriptionsSelector(state),
  title: I18n.t('Dashboard.LostAndStolen.selectSubscriptionToSuspendTitle'),
  confirmButtonText: I18n.t('Dashboard.LostAndStolen.suspendButton'),
  modalContent: subscription =>
    I18n.t('Dashboard.LostAndStolen.modalConfirmationText', {
      phoneNumber: FormatService.formatPhone(subscriptionToPhoneNumber(subscription)),
    }),
  loadingSelector: 'suspendSuccess',
});

const mapDispatchToProps: DispatchProps = {
  onConfirm: suspendLine,
};

export default connect(mapStateToProps, mapDispatchToProps)(PickLine);
